export default __webpack_public_path__ + "static/media/Camerron-4.11eb43b4.png";